import { createReducer, on } from "@ngrx/store";
import { UserModel } from "../models/user.model";
import { ADD_USER, UPDATE_USER } from "../actions/user.action";

const INITIAL_STATE: UserModel = {};

export const UserReducer = createReducer(
  INITIAL_STATE,
  on(ADD_USER, (_, { user }) => user),
  on(UPDATE_USER, (state, { user }) => ({ ...state, ...user })),
);
